var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-crabelab-text';
                    var viewUrl = 'sprite.svg#view-logo-crabelab-text';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-crabelab-text#logo-crabelab-text';
                            viewUrl = 'sprite.svg?logo-crabelab-text#view-logo-crabelab-text';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 139 55',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };